import React from 'react';
import { Badge } from 'react-bootstrap';

import { IReceita } from '../../../hooks/receita';

import { Container } from './styles';

interface Props {
  status: string;
  size?: 'sm' | 'lg';
}

const StatusBadge: React.FC<Props> = ({ status: statusProp, size = 'sm' }) => {
  const getVariant = (status: string): string => {
    switch (status) {
      case 'Criada':
        return 'warning';
      case 'Emitida':
        return 'success';
      case 'Cancelada':
        return 'danger';
      default:
        return 'secondary';
    }
  };

  const getLabel = (status: string): string => {
    switch (status) {
      case 'Criada':
        return 'Criada';
      case 'Emitida':
        return 'Emitida';
      case 'Cancelada':
        return 'Cancelada';
      default:
        return status;
    }
  };

  return (
    <Container>
      <Badge
        variant={getVariant(statusProp)}
        className={`text-capitalize ${size === 'lg' ? 'px-3 py-2' : ''}`}
      >
        {getLabel(statusProp)}
      </Badge>
    </Container>
  );
};

export default StatusBadge;
